module.exports = __webpack_public_path__ + "assets/img/LJ-Hooker-Pillar-Page-Resource-w960.76b19ef7.webp";